/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs */

const en_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detect Illegal Characters (Netflix)`)
};

const fr_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecter les caracteres illegaux (Netflix)`)
};

const de_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erkennung illegaler Zeichen (Netflix)`)
};

const it_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rileva personaggi illegali (Netflix)`)
};

const ru_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение недопустимых символов (Netflix)`)
};

const es_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar personajes ilegales (Netflix)`)
};

const zh_cn2_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测非法字符（Netflix）`)
};

const ja_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正な文字を検出する（Netflix）`)
};

const hi_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवैध वर्णों का पता लगाएं (नेटफ्लिक्स)`)
};

const pt_pt2_style_guide_manager_detect_illegal_netflix_label = /** @type {(inputs: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar caracteres ilegais (Netflix)`)
};

/**
* | output |
* | --- |
* | "Detect Illegal Characters (Netflix)" |
*
* @param {Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_detect_illegal_netflix_label = /** @type {((inputs?: Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Detect_Illegal_Netflix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_detect_illegal_netflix_label(inputs)
	if (locale === "de") return de_style_guide_manager_detect_illegal_netflix_label(inputs)
	if (locale === "it") return it_style_guide_manager_detect_illegal_netflix_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_detect_illegal_netflix_label(inputs)
	if (locale === "es") return es_style_guide_manager_detect_illegal_netflix_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_detect_illegal_netflix_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_detect_illegal_netflix_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_detect_illegal_netflix_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_detect_illegal_netflix_label(inputs)
	return en_style_guide_manager_detect_illegal_netflix_label(inputs)
});